import { useEffect, useState } from "react";

import theme from "theme";
import { colors } from "theme/palette";

import Box from "components/Box";
import Step from "components/Step";
import StepLabel from "components/StepLabel";
import Stepper from "components/Stepper";

import { MemoESignatureDrawerSteps } from "entities/Memo/components/Sections/MemoESignatureDrawer/constants";

const steps = ["Roles & contacts", "Notification email", "Review & send"];

const MemoESignatureStepper = ({
  currentStep,
}: {
  currentStep: MemoESignatureDrawerSteps;
}) => {
  const [activeStep, setActiveStep] = useState<number>(0);

  useEffect(() => {
    if (currentStep === MemoESignatureDrawerSteps.ROLES_AND_CONTACTS) {
      setActiveStep(0);
    }
    if (currentStep === MemoESignatureDrawerSteps.NOTIFICATION_EMAIL) {
      setActiveStep(1);
    }
    if (currentStep === MemoESignatureDrawerSteps.REVIEW_AND_SEND) {
      setActiveStep(2);
    }
  }, [currentStep]);

  return (
    <Box
      sx={{
        padding: theme.spacing(0, 3, 2, 3),
        backgroundColor: colors.blue10,
      }}
    >
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps: { completed?: boolean } = {};
          const labelProps: {
            optional?: React.ReactNode;
          } = {};

          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
};

export default MemoESignatureStepper;
